import PageTable from "./PageTable";
import { useEffect, useRef, useState } from "react";
import { getAPI } from "../../../../../API/ApiService";
import { BASE_URL } from "../../../../../constant/apiUrl";
import { useDispatch } from "react-redux";
import { setAdminPages } from "../../../../../slices/pageSlice";
import { modifiedArray } from "./commonfunction";
import BuilderListLayout from "../../Builder/BuilderListLayout/BuilderListLayout";
import { useNavigate } from "react-router-dom";

const PageBuilderList = () => {
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);
  const navigate = useNavigate();
  const handleSearch = (value) => {
    setSearchText(value);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAPI(`${BASE_URL}/admin/order/hierarchy`);
        if (response?.status === 200) {
          const newArray = modifiedArray(response?.data);
          dispatch(setAdminPages(newArray));
        }
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchData();
    }
  }, []);

  const createpages = () => {
    navigate("/admin/pageBuilder");
  };
  return (
    <BuilderListLayout
      title="Page builder"
      headerTitle="Current pages"
      buttonTitle="Create new page"
      handleSearch={handleSearch}
      onClick={createpages}
    >
      <PageTable searchText={searchText} loading={loading} />
    </BuilderListLayout>
  );
};

export default PageBuilderList;
